import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

export default class extends Controller {
  static targets = [
    'modalShared',
    'modalSharedForm',
    'modalSharedFrame'
  ]

  connect() {
    addEventListener('hidden.bs.modal', () => {
      this.modalSharedFrameTarget.innerHTML = null
      this.modalSharedFrameTarget.src = null
    })
  }

  modalSharedFormTargetConnected() {
    Modal.getOrCreateInstance(this.modalSharedTarget).show()
  }

  modalSharedFormTargetDisconnected() {
    Modal.getInstance(this.modalSharedTarget).dispose()
  }
}
